import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useCategorySales = (params, options = {}) => {
  return useQuery(
    ["categorySalesReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getCategorySales(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        grouping: res.data.data.grouping,
        reportData: res.data.data.report_data,
        reportHeader: res.data.data.report_header,
        salesHeader: res.data.data.sales_header,
        total: res.data.data.total,
      };
      return composeResponse;
    },
    options,
  );
};
